import { render, staticRenderFns } from "./ProfileBasic.vue?vue&type=template&id=3433976c&scoped=true&"
import script from "./ProfileBasic.vue?vue&type=script&lang=js&"
export * from "./ProfileBasic.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBasic.vue?vue&type=style&index=0&id=3433976c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3433976c",
  null
  
)

export default component.exports